// extracted by mini-css-extract-plugin
var _1 = "ZXlpa";
var _2 = "ePrxa";
export { _1 as "base", _2 as "progress" }
